import { memo, useMemo } from 'react';
import withErrorBoundary from '../../../../../core/components/errors/withErrorBoundary';

import { useProductDetailsQuery } from '../../../../queries/useProductDetails';
import type { ProductWithFixedRelatedProducts } from '../../../../util/processRelatedProducts';
import processRelatedProducts from '../../../../util/processRelatedProducts';
import ProductSummary from '../../../ProductDetails/ProductSummary';
import type { Product } from '../../../../types';

const SkuProductSearchProductDetails = memo(
    ({
        product,
        hideEmptyContent,
    }: {
        product: Pick<
            Product,
            'name' | 'id' | 'media' | 'manufacturer' | 'sku'
        > & {
            manufacturer?: string;
        };
        hideEmptyContent?: boolean;
    }) => {
        const { error, data } = useProductDetailsQuery({
            id: product.id,
        });

        if (error) {
            throw error;
        }

        const productFullInfo = useMemo(() => {
            return data?.product
                ? processRelatedProducts(data.product)
                : undefined;
        }, [data?.product]);

        const productInfo = productFullInfo
            ? productFullInfo
            : ({
                  ...product,
                  variants: [],
                  additionalCharges: [],
              } as unknown as ProductWithFixedRelatedProducts);

        return (
            <ProductSummary
                product={productInfo}
                hasVariants={false}
                selectedSku={productInfo.sku}
                selectedVariant={undefined}
                replacementProducts={[]}
                hideEmptyContent={hideEmptyContent}
            />
        );
    }
);

export default withErrorBoundary(SkuProductSearchProductDetails);
